import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22Gabarito.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./Gabarito/Gabarito-Black.ttf%22,%22weight%22:%22900%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-ExtraBold.ttf%22,%22weight%22:%22800%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-Medium.ttf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-Regular.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-SemiBold.ttf%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./Gabarito/Gabarito-VariableFont_wght.ttf%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--font-gabarito%22}],%22variableName%22:%22gabarito%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gabarito', 'gabarito Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
